import createCollectionStore from '../create';
import { fetchAll, saveLocation } from '../../core-data';
import { Location } from '../../core-data/types';
import UUID from 'uuid';

export default createCollectionStore(
  'Location',
  () => fetchAll(Location),
  'uuid',
  [],
  {
    save: async (state, actions, location) => {
      const modified = {
        uuid: UUID.v4(),
        ...location
      };
      await saveLocation(modified);
      await actions.updateCache(modified);
      return { };
    }
  }
);


// WEBPACK FOOTER //
// ./src/services/collection/collections/location.js